import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  scrollContent: {
    paddingVertical: spacing.m,
  },
}));
